import { ReactNode } from 'react';

export const DocumentUploadInfo = ({ children }: { children?: ReactNode }) => {
  return <div className="text-primary">{children}</div>;
};
